import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { api } from '../../services/api'; // Descomentar cuando tengas los endpoints

// ============================================================================
// ASYNC THUNKS - Operaciones asíncronas (TODO: Implementar con backend)
// ============================================================================

// TODO: Obtener citas del día
export const fetchTodayAppointments = createAsyncThunk(
  'lawyerDashboard/fetchTodayAppointments',
  async (_, { rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.get(`/lawyer/${auth.user.id}/appointments/today`);
      // return response.data;

      // PLACEHOLDER - Datos fake por ahora
      return [];
    } catch (error) {
      return rejectWithValue('Error al cargar citas');
    }
  }
);

// TODO: Obtener consultas pendientes
export const fetchPendingConsultations = createAsyncThunk(
  'lawyerDashboard/fetchPendingConsultations',
  async (_, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.get(`/lawyer/${auth.user.id}/consultations/pending`);
      // return response.data;

      // PLACEHOLDER
      return [];
    } catch (error) {
      return rejectWithValue('Error al cargar consultas');
    }
  }
);

// TODO: Obtener estadísticas del mes
export const fetchMonthlyStats = createAsyncThunk(
  'lawyerDashboard/fetchMonthlyStats',
  async (_, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.get(`/lawyer/${auth.user.id}/stats/monthly`);
      // return response.data;

      // PLACEHOLDER
      return {
        totalClients: 0,
        monthlyEarnings: 0,
        completedConsultations: 0,
        averageRating: 0,
      };
    } catch (error) {
      return rejectWithValue('Error al cargar estadísticas');
    }
  }
);

// TODO: Actualizar estado online/offline
export const toggleOnlineStatus = createAsyncThunk(
  'lawyerDashboard/toggleOnlineStatus',
  async (isOnline, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const response = await api.patch(`/lawyer/${auth.user.id}/status`, { isOnline });
      // return response.data;

      // PLACEHOLDER
      return { isOnline };
    } catch (error) {
      return rejectWithValue('Error al actualizar estado');
    }
  }
);

// TODO: Aceptar consulta express
export const acceptConsultation = createAsyncThunk(
  'lawyerDashboard/acceptConsultation',
  async (consultationId, { rejectWithValue }) => {
    try {
      // const response = await api.patch(`/consultations/${consultationId}/accept`);
      // return response.data;

      // PLACEHOLDER
      return { consultationId, status: 'accepted' };
    } catch (error) {
      return rejectWithValue('Error al aceptar consulta');
    }
  }
);

// ============================================================================
// INITIAL STATE - Estado inicial del dashboard del abogado
// ============================================================================

const INITIAL_STATE = {
  // Citas y agenda
  appointments: {
    today: [],
    upcoming: [],
    past: [],
    loading: false,
    error: null,
  },

  // Consultas express
  consultations: {
    pending: [],
    active: [],
    completed: [],
    loading: false,
    error: null,
  },

  // Estadísticas del abogado
  stats: {
    totalClients: 0,
    monthlyEarnings: 0,
    completedConsultations: 0,
    averageRating: 0,
    loading: false,
    error: null,
  },

  // Configuración del perfil profesional
  profile: {
    isOnline: false,
    availability: {
      // monday: { start: '09:00', end: '18:00', available: true },
      // tuesday: { start: '09:00', end: '18:00', available: true },
      // ... resto de días
    },
    specialties: [],
    pricing: {
      // hourlyRate: 0,
      // consultationRate: 0,
      // firstConsultationFree: false
    },
    loading: false,
    error: null,
  },

  // Estado de la UI del dashboard
  ui: {
    selectedTab: 'inicio', // 'inicio', 'encuentraAbogado', 'consultaExpress', 'estadisticas', 'perfil'
    showNotifications: false,
    filters: {
      appointmentStatus: 'all', // 'all', 'pending', 'confirmed', 'completed'
      dateRange: 'today', // 'today', 'week', 'month'
    },
    modals: {
      editProfile: false,
      newAppointment: false,
      consultationDetails: false,
    },
  },

  // Estado general
  isLoading: false,
  error: null,
  lastUpdated: null,
};

// ============================================================================
// SLICE - Definición del slice
// ============================================================================

const lawyerDashboardSlice = createSlice({
  name: 'lawyerDashboard',
  initialState: INITIAL_STATE,
  reducers: {
    // UI Actions - Acciones para manejar la interfaz
    setSelectedTab: (state, action) => {
      state.ui.selectedTab = action.payload;
    },

    toggleNotifications: state => {
      state.ui.showNotifications = !state.ui.showNotifications;
    },

    setFilter: (state, action) => {
      const { filterType, value } = action.payload;
      state.ui.filters[filterType] = value;
    },

    openModal: (state, action) => {
      const modalName = action.payload;
      state.ui.modals[modalName] = true;
    },

    closeModal: (state, action) => {
      const modalName = action.payload;
      state.ui.modals[modalName] = false;
    },

    closeAllModals: state => {
      Object.keys(state.ui.modals).forEach(modal => {
        state.ui.modals[modal] = false;
      });
    },

    // Data Actions - Acciones para datos locales
    updateLocalProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload };
    },

    addLocalAppointment: (state, action) => {
      state.appointments.today.push(action.payload);
    },

    removeLocalAppointment: (state, action) => {
      const appointmentId = action.payload;
      state.appointments.today = state.appointments.today.filter(apt => apt.id !== appointmentId);
    },

    // Clear Actions - Limpiar datos
    clearDashboardData: state => {
      return INITIAL_STATE;
    },

    clearErrors: state => {
      state.error = null;
      state.appointments.error = null;
      state.consultations.error = null;
      state.stats.error = null;
      state.profile.error = null;
    },
  },

  extraReducers: builder => {
    // Fetch Today Appointments
    builder
      .addCase(fetchTodayAppointments.pending, state => {
        state.appointments.loading = true;
        state.appointments.error = null;
      })
      .addCase(fetchTodayAppointments.fulfilled, (state, action) => {
        state.appointments.loading = false;
        state.appointments.today = action.payload;
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(fetchTodayAppointments.rejected, (state, action) => {
        state.appointments.loading = false;
        state.appointments.error = action.payload;
      });

    // Fetch Pending Consultations
    builder
      .addCase(fetchPendingConsultations.pending, state => {
        state.consultations.loading = true;
        state.consultations.error = null;
      })
      .addCase(fetchPendingConsultations.fulfilled, (state, action) => {
        state.consultations.loading = false;
        state.consultations.pending = action.payload;
      })
      .addCase(fetchPendingConsultations.rejected, (state, action) => {
        state.consultations.loading = false;
        state.consultations.error = action.payload;
      });

    // Fetch Monthly Stats
    builder
      .addCase(fetchMonthlyStats.pending, state => {
        state.stats.loading = true;
        state.stats.error = null;
      })
      .addCase(fetchMonthlyStats.fulfilled, (state, action) => {
        state.stats.loading = false;
        state.stats = { ...state.stats, ...action.payload, loading: false };
      })
      .addCase(fetchMonthlyStats.rejected, (state, action) => {
        state.stats.loading = false;
        state.stats.error = action.payload;
      });

    // Toggle Online Status
    builder
      .addCase(toggleOnlineStatus.pending, state => {
        state.profile.loading = true;
      })
      .addCase(toggleOnlineStatus.fulfilled, (state, action) => {
        state.profile.loading = false;
        state.profile.isOnline = action.payload.isOnline;
      })
      .addCase(toggleOnlineStatus.rejected, (state, action) => {
        state.profile.loading = false;
        state.profile.error = action.payload;
      });

    // Accept Consultation
    builder.addCase(acceptConsultation.fulfilled, (state, action) => {
      const { consultationId } = action.payload;
      // Mover consulta de pending a active
      const consultation = state.consultations.pending.find(c => c.id === consultationId);
      if (consultation) {
        state.consultations.pending = state.consultations.pending.filter(
          c => c.id !== consultationId
        );
        state.consultations.active.push({ ...consultation, status: 'active' });
      }
    });
  },
});

// ============================================================================
// EXPORTS - Acciones y selectores
// ============================================================================

// Export actions
export const {
  setSelectedTab,
  toggleNotifications,
  setFilter,
  openModal,
  closeModal,
  closeAllModals,
  updateLocalProfile,
  addLocalAppointment,
  removeLocalAppointment,
  clearDashboardData,
  clearErrors,
} = lawyerDashboardSlice.actions;

// Selectores específicos para el dashboard del abogado
export const selectLawyerDashboard = state => state.lawyerDashboard;
export const selectTodayAppointments = state => state.lawyerDashboard.appointments.today;
export const selectPendingConsultations = state => state.lawyerDashboard.consultations.pending;
export const selectMonthlyStats = state => state.lawyerDashboard.stats;
export const selectIsOnline = state => state.lawyerDashboard.profile.isOnline;
export const selectSelectedTab = state => state.lawyerDashboard.ui.selectedTab;
export const selectDashboardLoading = state => state.lawyerDashboard.isLoading;

export default lawyerDashboardSlice.reducer;
